export default {
    VUE_APP_ENV: `local`,
    VUE_APP_URL: process.env.VUE_APP_URLS__CMS,
    VUE_APP_API_URL: process.env.VUE_APP_URLS__CMS,
};
